
import React from "react";
import "../../App.css";

export default function FormProdutosVendas({ itemSelecionado, modo, onClose }) {
  return (
    <div className="Form-container">
      <div className="Form-header">
        <h2>
          {modo === "novo" ? "Novo Registro" : "Alterar Registro"}
        </h2>

        <button onClick={onClose}>X</button>
      </div>

      <div className="Form-body">
        <p>FormProdutosVendas de teste carregado com sucesso.</p>

        <p>
          <strong>Modo:</strong> {modo}
        </p>

        {itemSelecionado && (
          <pre style={{ background: "#f5f5f5", padding: "8px" }}>
            {JSON.stringify(itemSelecionado, null, 2)}
          </pre>
        )}
      </div>

      <div className="Form-footer">
        <button disabled>Salvar</button>
      </div>
    </div>
  );
}
